module.exports = __webpack_public_path__ + "static/iso9001-c8fdfbd71b1fd8b62524fb68042f0257.png";